import React from 'react';
import PropTypes from 'prop-types';
import Observer from '@researchgate/react-intersection-observer';

const ObserverBar = ({ setHeaderFixed, fixed }) => {
  const onChange = ({ isIntersecting }) => setHeaderFixed(!isIntersecting);

  const options = {
    onChange,
    disabled: !fixed,
  };

  return (
    <Observer {...options}>
      <div />
    </Observer>
  );
};

ObserverBar.propTypes = {
  setHeaderFixed: PropTypes.func,
  fixed: PropTypes.bool,
};

export default ObserverBar;
